import lodash from 'lodash';
import FORM_BUILDER from 'ui-blocks/form-builder/constants';
import {
   syndicatedSponsoredAdUnitCreate,
   syndicatedSponsoredAdUnitEdit,
   syndicatedSponsoredAdUnitGet,
} from '../../services/servicesSyndicatedSpondoredAds';

const formBuilderConfig = {
   // form: {
   //    header: 'Header TEST',
   //    subheader: 'Subheader TEST',
   //    sections: [
   //       {
   //          header: 'Header Section',
   //          subheader: 'subheader section',
   //          content: {
   //             type: FORM_BUILDER.FORM.SECTION.CONTENT.TYPE.FLEX_FIELDS,
   //             fields: [
   //                {
   //                   name: 'testname',
   //                   label: 'Partner',
   //                   component: TextInput,
   //                },
   //             ],
   //          },
   //       },
   //    ],
   // },
   defaultInitialValues: {
      backgroundColor: '#ffffff',
      titleColor: '#0000FF',
      copyColor: '#808080',
      urlColor: '#000000',
      borderColor: '#ffffff',
      fontSize: {
         label: 'Medium',
         value: 'medium',
      },
      fontFamily: {
         label: 'Arial',
         value: 'Arial',
      },
      borderWidth: 0,
      includeLogo: {
         label: 'No',
         value: 'n',
      },
      logoSize: {
         label: 'Small',
         value: 32,
      },
      numAds: {
         label: '1',
         value: 1,
      },
   },
   settings: {
      type: FORM_BUILDER.TYPE.EDIT_ADD,
      internal: {
         routing: {
            basePath: '/syndicated-sponsored-ads/ad-manager',
         },
      },
      external: {
         api: {
            get: syndicatedSponsoredAdUnitGet,
            save: {
               create: syndicatedSponsoredAdUnitCreate,
               edit: syndicatedSponsoredAdUnitEdit,
            },
            // getInitialValues:       -- value is a promise
            // save :                  -- has two value variations to take into consideration for the (1) Case: theres one API for
            //                            create & edit and for the (2) Case: where theres two separate APIs for 'create' and 'edit'
            //          E.g., Save Variation Value #1 -- value is a promise
            //          E.g., Save Variation Value #2 -- value is an object with the shape
            //                {
            //                   edit,       // -- value is a promise
            //                   create,     // -- value is a promise
            //                }

            responseMiddleware: {
               get: (resData) => {
                  const data = resData?.data || {};
                  const retVal = ({
                     ...data,
                     channel: {
                        ...(data?.channel || {}),
                        label: data?.channel?.name,
                        value: data?.channel?.id,
                     },
                     site: {
                        ...(data?.site || {}),
                        label: data?.site?.name,
                        value: data?.site?.id,
                     },
                     publisher: {
                        ...(data?.publisher || {}),
                        label: data?.publisher?.name,
                        value: data?.publisher?.id,
                     },
                     fontFamily: lodash.isString(data?.fontFamily) ? data.fontFamily.toLowerCase() : data?.fontFamily,
                  });
                  return retVal;
               },
            },
         },
      },
   },
};

export default formBuilderConfig;

